import { render, staticRenderFns } from "./taskdetail.vue?vue&type=template&id=421d49f5&scoped=true&"
import script from "./taskdetail.vue?vue&type=script&lang=js&"
export * from "./taskdetail.vue?vue&type=script&lang=js&"
import style0 from "./taskdetail.vue?vue&type=style&index=0&id=421d49f5&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d49f5",
  null
  
)

export default component.exports